"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var app_theme_defaule_1 = tslib_1.__importDefault(require("./app-theme-defaule"));
var appThemeDark = tslib_1.__assign(tslib_1.__assign({}, app_theme_defaule_1.default), { MuiMenu: {
        paper: {
            background: "rgb(48, 50, 55)",
        },
    }, DirectoryTitle: {
        color: "rgb(142, 146, 151)",
    }, settingWrap: {
        backgroundColor: "rgb(47, 49, 54)",
    }, settingDirectory: {
        backgroundColor: "rgb(47, 49, 54)",
    }, settingContent: {
        backgroundColor: "rgb(54, 57, 63)",
    }, Setting: {
        color: "rgb(114,118,125)",
        color2: "rgb(220, 221, 222)",
        color3: "rgb(255, 255, 255)",
        color4: "rgb(185, 187, 190)",
        color5: "rgb(114,118,125)",
        color6: "rgb(173,173,173)",
        color7: "rgb(255, 255, 255)",
        color8: "rgb(41, 43, 47)",
        color9: "rgb(32, 34, 37)",
        color10: "rgb(121,125,130)",
        color11: "rgb(66, 69, 74)",
        color12: "rgb(246,246,247)",
        color13: "rgb(48, 50, 55)",
        color14: "rgb(54, 57, 63)",
        color15: "rgb(221, 221, 222)",
        color16: "rgb(47, 49, 54)",
        color17: "rgb(47, 49, 54)",
        color18: "rgb(38,40,44)",
        color19: "rgb(29,31,34)",
    }, DirectoryViewWrap: {
        backgroundColor: "rgb(66,50,55)",
    }, SettingDirectory: {
        backgroundColor: "rgb(57, 60, 67)",
    }, SmallTitle: {
        color: "rgb(185, 187, 190)",
    }, DesTitle: {
        color: "rgb(142, 146, 151)",
    }, SettingUserInfoView: {
        borderColor: "rgb(32, 34, 37)",
        backgroundColor: "rgb(41, 43, 47)",
        UserInfoView_text: "rgb(121, 125, 130)",
        UserInfoView_name: "rgb(185, 187, 190)",
        UserInfoView_namecode: "rgb(113, 114, 119)",
    }, SettingRoundRadioButtonView: {
        radioIcon: "rgb(114, 118, 125)",
        language: "rgb(220, 221, 222)",
        country: "rgb(185, 187, 190)",
    }, SettingBoxRadioButtonGroupView: {
        borderColor: "rgb(32,34,37)",
        backgroundColor: "rgb(48, 50, 55)",
        radioBoxContentDesDefaultColor: "rgb(185,187,190)",
        radioBoxContentDesChoosedColor: "rgb(255,255,255)",
        radioIconDefaultColor: "rgb(114,118,125)",
        radioIconChoosedColor: "rgb(255,255,255)",
    }, DirectoryViewTextBlueColor: {
        backgroundColor: "rgb(53,58,70)",
    } });
exports.default = appThemeDark;
//# sourceMappingURL=app-theme-dark.js.map